/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 16,
    height: 16,
    viewBox: '0 0 29 30',
    data: '<path pid="0" d="M8 21.7V16c0-.6.4-1 1-1s1 .4 1 1v5.7c0 .6-.4 1-1 1s-1-.5-1-1zm12 1c.6 0 1-.4 1-1V16c0-.6-.4-1-1-1s-1 .4-1 1v5.7c0 .5.4 1 1 1zm-5.5.9c.6 0 1-.4 1-1V12c0-.6-.4-1-1-1s-1 .4-1 1v10.6c0 .5.4 1 1 1zM28.6 7c0 .6-.4 1-1 1H26v18.5c0 1.6-1.2 2.9-2.8 2.9H5.8c-1.5 0-2.8-1.3-2.8-2.9V8H1c-.6 0-1-.4-1-1s.4-1 1-1h7V2.9C8 1.3 9.3 0 10.9 0h7.6c1.6 0 2.9 1.3 2.9 2.9V6h6.2c.5 0 1 .4 1 1zM10 6h9.4V2.9c0-.5-.4-.9-.9-.9h-7.6c-.5 0-.9.4-.9.9V6zm14 2H5v18.5c0 .5.4.9.8.9h17.5c.4 0 .7-.4.7-.9V8z"/>'
  }
})
